(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var slideshows = document.querySelectorAll('.accio-hero-slideshow');
  slideshows.forEach(function(section) {
    var track = section.querySelector('.accio-hero-slideshow__track');
    var prevBtn = section.querySelector('.accio-hero-slideshow__arrow--prev');
    var nextBtn = section.querySelector('.accio-hero-slideshow__arrow--next');
    var dots = section.querySelectorAll('.accio-hero-slideshow__dot');

    var currentIndex = 0;
    var totalSlides = dots.length;
    var autoplayInterval = null;
    var autoplayDelay = 5000;

    if (!track || totalSlides === 0) return;

    function goToSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentIndex = index;
      track.style.transform = 'translateX(-' + (index * (100 / totalSlides)) + '%)';
      dots.forEach(function(dot, i) {
        dot.classList.toggle('accio-hero-slideshow__dot--active', i === currentIndex);
        dot.setAttribute('aria-selected', i === currentIndex ? 'true' : 'false');
      });
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayInterval = setInterval(function() {
        goToSlide(currentIndex + 1);
      }, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayInterval) clearInterval(autoplayInterval);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        goToSlide(currentIndex - 1);
        stopAutoplay();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        goToSlide(currentIndex + 1);
        stopAutoplay();
        startAutoplay();
      });
    }

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        goToSlide(i);
        stopAutoplay();
        startAutoplay();
      });
    });

    var startX = 0;
    var currentX = 0;
    var isDragging = false;

    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      currentX = startX;
      isDragging = true;
      stopAutoplay();
      track.style.transition = 'none';
    }, {passive: true});

    track.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
      var diff = currentX - startX;
      var baseTransform = -(currentIndex * (100 / totalSlides));
      var diffPercent = (diff / track.offsetWidth) * 100;
      track.style.transform = 'translateX(' + (baseTransform + diffPercent) + '%)';
    }, {passive: true});

    track.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      
      var diff = currentX - startX;
      var threshold = window.innerWidth * 0.15;
      
      if (Math.abs(diff) > threshold && currentX !== startX) {
        if (diff > 0) {
          goToSlide(currentIndex - 1);
        } else {
          goToSlide(currentIndex + 1);
        }
      } else {
        goToSlide(currentIndex);
      }
      startAutoplay();
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});

  } catch(e) { console.error(e); }
})();
})();
